const initialState = {
  filtersBootstrapped: false,
  leadScope: null,
  trackLeadScope: false,
  filters: {
    companyAgents: [],
    selectAgents: [],
    selectBranches: [],
    selectTeams: [],
    tags: [],
    loadingAgents: true,
    loadingBranches: true,
    loadingTeams: true,
    loadingTags: false,
    selectedIds: [],
  },
};

export default initialState;
